import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const SubscriptIcon = (props)=>{
    const $ = c(7);
    let t0;
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M14.4628 14H11.8671C11.4205 14 11.2263 13.7418 11.2263 13.3865C11.2263 13.125 11.3428 12.9239 11.6017 12.6993L12.8866 11.5595C13.4109 11.0935 13.5598 10.8823 13.5598 10.594C13.5598 10.289 13.3332 10.0778 12.9999 10.0778C12.7539 10.0778 12.5856 10.1951 12.4109 10.4566C12.2296 10.7315 12.0646 10.8321 11.8024 10.8321C11.4529 10.8321 11.2393 10.6209 11.2393 10.2789C11.2393 10.1683 11.2587 10.0644 11.3008 9.96382C11.5467 9.38722 12.2037 9.02853 13.0193 9.02853C14.1553 9.02853 14.8803 9.62188 14.8803 10.5002C14.8803 11.1505 14.5566 11.4891 13.8316 12.1394L12.9805 12.9004V12.9272H14.4628C14.8058 12.9272 15 13.1384 15 13.4636C15 13.7821 14.8058 14 14.4628 14Z"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M2.64642 2C2.88227 2 3.09935 2.13024 3.2126 2.3397L5.72818 6.99219H5.80998L8.32391 2.34275C8.43818 2.13141 8.6572 2 8.89517 2C9.39175 2 9.70564 2.54011 9.46448 2.97961L6.70973 8L9.4632 13.0181C9.70493 13.4586 9.3903 14 8.89255 14C8.6559 14 8.43777 13.8703 8.32247 13.6611L5.80998 9.10156H5.72818L3.21402 13.6641C3.09975 13.8715 2.88357 14 2.64902 14C2.1527 14 1.84121 13.4575 2.08678 13.0208L4.91023 8L2.0855 2.97687C1.8405 2.5412 2.15126 2 2.64642 2Z"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M14.4628 14H11.8671C11.4205 14 11.2263 13.7418 11.2263 13.3865C11.2263 13.125 11.3428 12.9239 11.6017 12.6993L12.8866 11.5595C13.4109 11.0935 13.5598 10.8823 13.5598 10.594C13.5598 10.289 13.3332 10.0778 12.9999 10.0778C12.7539 10.0778 12.5856 10.1951 12.4109 10.4566C12.2296 10.7315 12.0646 10.8321 11.8024 10.8321C11.4529 10.8321 11.2393 10.6209 11.2393 10.2789C11.2393 10.1683 11.2587 10.0644 11.3008 9.96382C11.5467 9.38722 12.2037 9.02853 13.0193 9.02853C14.1553 9.02853 14.8803 9.62188 14.8803 10.5002C14.8803 11.1505 14.5566 11.4891 13.8316 12.1394L12.9805 12.9004V12.9272H14.4628C14.8058 12.9272 15 13.1384 15 13.4636C15 13.7821 14.8058 14 14.4628 14Z",
            strokeWidth: "0.3"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M2.64642 2C2.88227 2 3.09935 2.13024 3.2126 2.3397L5.72818 6.99219H5.80998L8.32391 2.34275C8.43818 2.13141 8.6572 2 8.89517 2C9.39175 2 9.70564 2.54011 9.46448 2.97961L6.70973 8L9.4632 13.0181C9.70493 13.4586 9.3903 14 8.89255 14C8.6559 14 8.43777 13.8703 8.32247 13.6611L5.80998 9.10156H5.72818L3.21402 13.6641C3.09975 13.8715 2.88357 14 2.64902 14C2.1527 14 1.84121 13.4575 2.08678 13.0208L4.91023 8L2.0855 2.97687C1.8405 2.5412 2.15126 2 2.64642 2Z",
            strokeWidth: "0.3"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] !== props.height || $[5] !== props.width) {
        t4 = /*#__PURE__*/ jsxs("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3
            ]
        });
        $[4] = props.height;
        $[5] = props.width;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
export { SubscriptIcon };
